import { GenericInfoField } from "../../../../common/components/ui/GenericInfoField";
import { usePartnerDashboardContext } from "../partner-dashboard/usePartnerDashboardContext";
import { personalPartnerInfo } from "./partner-edit-contants";

function PartnerInfo() {
  const { partner } = usePartnerDashboardContext();
  const setPartnerInfo = personalPartnerInfo(partner);

  return (
    <div className="tabs-border-line">
      <section className="tabs-item-style">
        <h2 className="text-2xl font-semibold mb-4">Informações Pessoais</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 grid-rows-3 mb-8 gap-2">
          {setPartnerInfo.map((info) => {
            return (
              <GenericInfoField
                id={info.id}
                spanSize={info.spanSize}
                label={info.label}
                value={info.value}
              />
            );
          })}
        </div>
      </section>
    </div>
  );
}
export default PartnerInfo;
